import { toAdvancedRichText } from '@framework/engine/inputs/rich-text-advanced/render/toAdvancedRichText.ts';
import { RichTextAdvancedSchema } from '@framework/engine/inputs/rich-text-advanced/schema/RichTextAdvancedSchema.ts';
import { DefaultAssignableExpressionSchema } from '@framework/engine/schema/expressions/repository/assignable/AssignableExpressionSchema.ts';
import { CommonInputWidgetConfigSchema } from '@framework/engine/schema/widgets/repository/inputs/common/CommonInputConfigComponent.tsx';
import { yup } from '@framework/validation/initYup.ts';
import { type IProvinceWidget, WidgetProvinceType } from './IProvinceWidget.ts';

export const ProvinceWidgetConfigSchema: yup.ObjectSchema<IProvinceWidget> =
  CommonInputWidgetConfigSchema.shape({
    label: yup.mixed().strip(),
    type: yup.string().exact(WidgetProvinceType).required(),
    placeholder: yup.mixed().strip(),
    provinceLabel: RichTextAdvancedSchema.nonNullable().default(() =>
      toAdvancedRichText('Provincia'),
    ),
    townLabel: RichTextAdvancedSchema.nonNullable().default(() =>
      toAdvancedRichText('Comune'),
    ),
    provincePlaceholder: yup.string().notRequired().default('Provincia'),
    townPlaceholder: yup.string().notRequired().default('Comune'),

    provinceHelpText: RichTextAdvancedSchema.optional()
      .nonNullable()
      .default(() => toAdvancedRichText('')),
    townHelpText: RichTextAdvancedSchema.optional()
      .nonNullable()
      .default(() => toAdvancedRichText('')),

    defaultProvince: DefaultAssignableExpressionSchema.optional(),
    defaultTown: DefaultAssignableExpressionSchema.optional(),
    municipalityGroupList: yup
      .array()
      .of(yup.string().required())
      .notRequired()
      .label('Gruppo Comuni'),
  })
    .required()
    .noUnknown();
